import { trackGA4Event } from '@/helpers/track'

export const trackCmsToolCtaClick = (id_bloc, category_parent, category_enfant) => {
  trackGA4Event('click_cta_bloc_outils', { id_bloc, category_parent, category_enfant })
}

export const trackCmsArticleCtaClick = (id_cta, category_parent, category_enfant) => {
  trackGA4Event('click_cta_article', { id_cta, category_parent, category_enfant })
}
